import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { Section, WizardContext } from "../../context/Wizard";
import { SecondaryTabs } from "./SecondaryTabs";

export const SectionChips = () => {
  const { t } = useTranslation();
  const { section, setQuantity, setSection } = useContext(WizardContext);

  const tabs: { displayName: string; name: Section; onClick?: () => void }[] = useMemo(
    () => [
      { displayName: t("Modernization.wizard.crrem"), name: "crrem" },
      {
        displayName: t("BuildingProfile.kpis.energyEfficiencyClass"),
        name: "energy",
        onClick: () => {
          setQuantity("consumption");
        },
      },
    ],
    [t, setQuantity]
  );

  const activeTab = useMemo(() => tabs.find((tab) => tab.name === section) ?? tabs[0], [section, tabs]);

  return (
    <SecondaryTabs<{ displayName: string; name: Section; onClick?: () => void }>
      activeTab={activeTab}
      handleTabChange={(tab) => setSection(tab.name)}
      tabs={tabs}
    />
  );
};
